import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { mapSaverShip } from '../tiles/mapSaverShip-sidecar'
import { IButton } from '../uiParts/buttons'
import { buttons } from '../uiParts/buttons-sidecar'
import { dialogs } from '../uiParts/dialogs-sidecar'

interface IOpener {
  button: IButton
  name: string
}
interface IData {
  isOpen: boolean
  dialog: dialogs.IDialog
  openers: IOpener[]
}
let _data: IData | null = null
export const getData = () => {
  if (!_data) {
    _data = {
      isOpen: false,
      dialog: dialogs.create(10, 15, 200, 50, 'Open Map', () => {
        doClose()
      }),
      openers: [],
    }
    doClose()
  }
  return _data
}

export const doClose = () => {
  let data = getData()
  dialogs.setVisible(data.dialog, false)
  data.isOpen = false

  l.forEach(data.openers, (c) => {
    buttons.kill(c.button)
  })
  data.openers = []
}

export const open = async () => {
  let data = getData()
  if (data.isOpen) {
    doClose()
    return
  }
  data.isOpen = true
  dialogs.setVisible(data.dialog, true)

  let list = await mapSaverShip.getFilesList()

  let y = 50 + 50
  l.forEach(list, (c) => {
    let button = buttons.create(layers.getLayers().ui, 200, y, c, () => {
      mapSaverShip.loadNow(c)
      doClose()
    })
    data.openers.push({
      name: c,
      button,
    })
    y += 50
  })
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
}
